export default __webpack_public_path__ + "static/media/badminton.86985f2a.jpg";